import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { push } from 'shared-modules/redux/actions/routerActions';
import { useDispatch } from 'react-redux';
import { MODAL_SIZES } from 'shared-modules/constants';
import classNames from 'classnames';
import { HOME } from '../../../../../constants';
import { Button, Modal } from '../../../../../components';
import styles from '../../RunAutoTradeComponents/runSuccess.module.scss';
import { closeOmakasePlanModal } from '../../../../../redux/actions/modalActions';

export const SuccessModal = memo(({ isOpen, closeModal }) => {
  const dispatch = useDispatch();

  const handleRedirectToPortfolio = useCallback(() => {
    closeModal();
    dispatch(closeOmakasePlanModal());
    // for waiting close animation
    setTimeout(() => {
      dispatch(push(`/${HOME}`));
    }, 300);
  }, [closeModal, dispatch]);
  // TODO  constantsとして抽出
  return (
    <Modal
      isOpen={isOpen}
      closeModal={closeModal}
      size={MODAL_SIZES.WIDTH_400}
      headerStyle={styles.modalHeader}
      isOverlap
    >
      <div className={styles.iconContainer}>
        <i className={classNames('material-icons-outlined', styles.icon)}>task_alt</i>
      </div>
      <div className={styles.row}>自動売買を開始しました</div>
      <div className={styles.title}>注文の状況はホーム画面のポートフォリオ内にて確認できます。</div>

      <div className={styles.buttonWrapper}>
        <Button secondary onClick={handleRedirectToPortfolio} className={classNames(styles.button)} width={320}>
          ホーム画面へ
        </Button>
      </div>
    </Modal>
  );
});

SuccessModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};
